import {AlpineComponent} from 'alpinejs';
import {Dropdown} from 'bootstrap';

const SCROLL_DELTA = 50;

type HeaderData = {
  isHidden: boolean,
  isMobile: () => boolean,
  lastScrollPosition: number,
  toggleMobileNav: () => void,
  toggleSubNav: (event: Event, closeNav: boolean) => void,
}

export default (): AlpineComponent<HeaderData> => ({
  isHidden: false,
  lastScrollPosition: window.pageYOffset,

  init() {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset >= 0) {
        if (Math.abs(window.pageYOffset - this.lastScrollPosition) >= SCROLL_DELTA) {
          this.isHidden = window.pageYOffset >= this.lastScrollPosition;
          this.lastScrollPosition = window.pageYOffset;
        }
      }
    });

    const dropdownElements = Array.from(this.$root.querySelectorAll('.dropdown-toggle'));
    if (dropdownElements.length) {
      dropdownElements.map((item: any) => {
        return new Dropdown(item);
      });
    }
  },

  isMobile() {
    const mobileNavToggle = this.$refs.mobileNavToggle;
    return mobileNavToggle.offsetParent !== null;
  },

  toggleMobileNav() {
    const mobileNav = this.$refs.mobileNav;
    if (mobileNav) {
      document.body.classList.toggle('mobile-nav-opened');
      if (document.body.classList.contains('mobile-nav-opened')) {
        const activeNavItems: Array<HTMLElement> = [];
        Array.from<HTMLAnchorElement>(mobileNav.querySelectorAll('a.active')).forEach((link) => {
          const activeNavItem = link.parentElement;
          if (activeNavItem && activeNavItem.classList.contains('sub')) {
            activeNavItems.push(activeNavItem);
          }
        });
        if (activeNavItems.length) {
          document.body.classList.add('main-sub-nav-opened');
        }
      } else { // closing mobile nav
        Array.from<HTMLAnchorElement>(mobileNav.querySelectorAll('.js-opened')).forEach((item) => {
          item.classList.remove('js-opened');
        });
      }
    }
  },

  toggleSubNav(event: Event, closeNav: boolean) {
    const navItem = (<HTMLElement>event.target).parentElement;
    if (closeNav) {
      this.$root.querySelector('.main-nav-item.js-opened')?.classList.remove('js-opened');
      document.body.classList.remove('main-sub-nav-opened');
    }
    if (navItem?.classList.contains('sub')) {
      if (this.isMobile()) {
        event.preventDefault();
      }
      navItem.classList.toggle('js-opened');
      document.body.classList.add('main-sub-nav-opened');
    }
  }
});
